module.exports = __webpack_public_path__ + "static/media/icon-atendimento.3972a292.svg";